var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldSignupLeftpanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85941 4.42869V11.5668C2.85942 13.8231 3.54314 16.0263 4.82043 17.8862C6.09772 19.746 7.90861 21.1752 10.0144 21.9852L10.9903 22.3602C11.6403 22.6103 12.3598 22.6103 13.0097 22.3602L13.9856 21.9852C16.0914 21.1752 17.9023 19.746 19.1797 17.8862C20.4569 16.0263 21.1406 13.8231 21.1406 11.5668V4.42869C21.1424 4.16008 21.0666 3.89667 20.9223 3.67014C20.7779 3.44362 20.5712 3.26362 20.3269 3.15181C17.7018 2.00599 14.8643 1.42743 12 1.454C9.13584 1.42743 6.29832 2.00599 3.67316 3.15181C3.42892 3.26362 3.22218 3.44362 3.07782 3.67014C2.93346 3.89667 2.85762 4.16008 2.85941 4.42869Z",
    stroke: "#F58220",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 9.89062H9.1875C8.41085 9.89062 7.78125 10.5203 7.78125 11.2969V15.5156C7.78125 16.2923 8.41085 16.9219 9.1875 16.9219H14.8125C15.5891 16.9219 16.2188 16.2923 16.2188 15.5156V11.2969C16.2188 10.5203 15.5891 9.89062 14.8125 9.89062Z",
    stroke: "#F58220",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.67188C11.2541 5.67188 10.5387 5.96819 10.0113 6.49564C9.48382 7.02308 9.1875 7.73845 9.1875 8.48438V9.89063H14.8125V8.48438C14.8125 7.73845 14.5162 7.02308 13.9887 6.49564C13.4613 5.96819 12.7459 5.67188 12 5.67188Z",
    stroke: "#F58220",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7891C11.8058 13.7891 11.6484 13.6317 11.6484 13.4375C11.6484 13.2433 11.8058 13.0859 12 13.0859",
    stroke: "#F58220",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7891C12.1942 13.7891 12.3516 13.6317 12.3516 13.4375C12.3516 13.2433 12.1942 13.0859 12 13.0859",
    stroke: "#F58220",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldSignupLeftpanel);
export default __webpack_public_path__ + "static/media/shield-signup-leftpanel.6c0ca35f9c56c12815eff25444fad078.svg";
export { ForwardRef as ReactComponent };